import React from "react";
import { useNavigate } from "react-router-dom";
import { Colors, FontFamily, Main, PrimaryButton } from "utils/imports.utils";
import { ButtonSize, ButtonTypes } from "utils/interface.utils";
import "./reset_password_successful.screen.scss";

const ResetPasswordSuccessful = () => {
    const navigate = useNavigate();

    return (
        <Main backgroundColor={Colors.screenBackground} isRenderOnlyLogo={true} logoSize={{width: "200px", height: "83px"}}>
            <div className="reset_password_successful">
                <div className="reset_password_successful_container">
                    <div className="reset_password_successful_header">
                        <div className="reset_password_successful_header_title">
                            Password reset successful
                        </div>
                        <div className="reset_password_successful_header_desc">
                            Head back to the login page to login
                        </div>
                    </div>
                    <div className="reset_password_successful_buttons">
                        <div className="reset_password_successful_buttons_back">
                            <PrimaryButton
                                onClick={() => navigate('/login')}
                                text="Back to login"
                                type={ButtonTypes.PRIMARY_GRADIENT}
                                size={ButtonSize.LARGE}
                                fontFamily={FontFamily.semiBold}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Main>
    )
}

export default ResetPasswordSuccessful;